import type { KeyValueStore } from '../core';
import { sfx } from '../audio/sfx';
import { browserStore } from './loadoutStore';

const KEY = 'critter.duelMusic';

/** Default on. Off mutes the duel bed only; menus keep their loop. */
export function parseDuelMusic(raw: string | null): boolean {
  return raw !== 'off' && raw !== 'false';
}

export function loadDuelMusic(store: KeyValueStore = browserStore): boolean {
  return parseDuelMusic(store.getItem(KEY));
}

export function saveDuelMusic(on: boolean, store: KeyValueStore = browserStore): void {
  store.setItem(KEY, on ? 'on' : 'off');
  sfx.setDuelMusic(on);
}

export function toggleDuelMusic(store: KeyValueStore = browserStore): boolean {
  const next = !loadDuelMusic(store);
  saveDuelMusic(next, store);
  return next;
}

/** Apply the saved switch before a duel asks the bed to play. */
export function installDuelMusic(store: KeyValueStore = browserStore): void {
  sfx.setDuelMusic(loadDuelMusic(store));
}
